"use client";

import React, { createContext, useContext } from "react";

/** True when the page is being served on a booking site's own domain (so it must behave as a public page). */
const SiteHostContext = createContext(false);

export function SiteHostProvider({ isSiteHost, children }: { isSiteHost: boolean; children: React.ReactNode }) {
  return <SiteHostContext.Provider value={isSiteHost}>{children}</SiteHostContext.Provider>;
}

export function useIsSiteHost(): boolean {
  return useContext(SiteHostContext);
}
